import * as React from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "components/common";
import useWidgetSummaryUnavailableReason from "ai/widget-summary/useWidgetSummaryUnavailableReason";
const WidgetSummaryButton = ({ widgetType, widgetEmpty, noData, onClick }) => {
  const { t } = useTranslation("enterprise_ai");
  const unavailableReason = useWidgetSummaryUnavailableReason(widgetType);
  let disabledReason = unavailableReason;
  if (!disabledReason && widgetEmpty) {
    disabledReason = t("widget_summary_button.widget_empty");
  } else if (!disabledReason && noData) {
    disabledReason = t("widget_summary_button.no_data");
  }
  return /* @__PURE__ */ React.createElement(
    IconButton,
    {
      disabled: !!disabledReason,
      name: "note_add",
      iconType: "regular",
      title: disabledReason ? t("widget_summary_button.title_disabled", { reason: disabledReason }) : t("widget_summary_button.title"),
      onClick
    }
  );
};
export default WidgetSummaryButton;
